export default __webpack_public_path__ + "static/media/bummer@2x.2ec5241c.png";